import React, { useState } from "react";
import "./button.css";

const Button = ({
  text,
  action,
  disabled = false,
  color = "red",
  classNames = "",
  padding = "md",
  fill = true,
  type = "button",
}) => {
  const [hover, setHover] = useState(false);

  const classes = [
    "casvi-button",
    fill ? `fill-${color}` : `border-${color}`,
    `padding-${padding}`,
    hover && !disabled ? "is-hover" : "",
    disabled ? "is-disabled" : "",
    classNames,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={disabled ? undefined : action}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {text}
    </button>
  );
};

export default Button;
